import { motion } from "framer-motion";
import PageHeader from "@/components/PageHeader";
import { Reveal, Stagger, staggerItem } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import { useSeo } from "@/lib/seo";
import { useBrand } from "@/context/SiteContext";
import { BRANDS } from "@/data/content";

export default function Brands() {
  const brand = useBrand();
  useSeo({ title: `Brands & Partners | ${brand.name}`, description: "We work with established brands across solar inverters, UPS systems, batteries, solar modules and energy solutions to provide application-specific product choices.", canonical: `https://${brand.domain}/brands` });
  return (
    <div>
      <PageHeader label="Brands" title="Multi-Brand Product Availability" sub="We work with a wide range of established brands across solar inverters, UPS systems, batteries, solar modules, EV charging and energy solutions — allowing us to provide application-specific product choices to customers and B2B partners." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-12">
        {Object.entries(BRANDS).map(([cat, list]) => (
          <Reveal key={cat}>
            <div className="mono-label mb-4">{cat}</div>
            <Stagger className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {list.map((b) => (
                <motion.div key={b} variants={staggerItem} className="card-surface p-6 flex items-center justify-center text-center min-h-[90px]">
                  <span className="font-display font-semibold text-slate-200">{b}</span>
                </motion.div>
              ))}
            </Stagger>
          </Reveal>
        ))}
        <div className="card-surface p-5 border-amber-500/30 !bg-amber-500/5 max-w-3xl">
          <div className="mono-label !text-amber-400">Note</div>
          <p className="text-sm text-slate-300 mt-1">Brand names and logos are editable records. We do not display "Authorized Dealer", "Authorized Distributor", "Official Partner" or "Certified Dealer" unless that exact relationship is verified.</p>
        </div>
      </section>
      <CTASection />
    </div>
  );
}
